import styled from 'styled-components/macro';
import theme from 'shared/css/theme';

export const DROPDOWN_PADDING = 5;
const CONTENT_WIDTH = theme.spacing?.(30);

export const NavDropDownContentStyled = styled.div`
  ${({ theme: { colors = {} }, isOverflowing, hideDropdown }) => `
    ${hideDropdown && 'display: none'};
    z-index: 1;
    display: grid;
    position: ${isOverflowing ? 'fixed' : 'absolute'};
    ${isOverflowing && `right: ${DROPDOWN_PADDING}px`};
    max-width: 100vw;
    max-height: 90vh;
    background-color: ${colors.outline?.default};
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    box-shadow: 0px 4px 7px rgba(0, 0, 0, 0.06);
    border-radius: 2px;
    grid-template-columns: repeat(auto-fit, minmax(${CONTENT_WIDTH}, 1fr));
    overflow-y: scroll;
    ::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, .5);
      box-shadow: 0 0 1px rgba(255, 255, 255, .5);
    }
  `}
`;

export const NavDropDownContentColumnStyled = styled.div`
  ${({ theme: { spacing } }) => `
    display: flex;
    flex-direction: column;
    margin-bottom: ${spacing?.(1)};
    width: ${CONTENT_WIDTH};
    min-width: ${CONTENT_WIDTH};
  `}
`;
